const overrideRadio = (theme) => {
  theme.overrides.MuiSwitch = {
    root: {
      marginLeft: -14
    },
    colorPrimary: {
      color: theme.colorPalette.beige_50,
      '&$checked': {
        color: theme.colorPalette.orange_50
      }
    },
    colorSecondary: {
      height: 'auto',
      color: theme.colorPalette.green_80
    },
    disabled: {
      color: theme.colorPalette.orange_50_op_70
    }
  };
};

export default overrideRadio;
